import { RouteItem } from '@eastcoal/router/types/route'

import { REGION_PAGE_PATH } from './constants/path'
import { REGION_ACTION_UUID, REGION_PAGE_UUID } from './constants/uuid'

export const regionRoute: RouteItem = {
  title: '行政区域',
  path: REGION_PAGE_PATH,
  uuid: REGION_PAGE_UUID,
  Component: () => import('./index'),
  children: [
    {
      title: '管理行政区域',
      uuid: REGION_ACTION_UUID
    }
  ]
}
